// src/pages/Catalog/index.js - Modified to include tabs
import React, { useState } from "react";
import { Tabs, Tab, Paper, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import ProductsTab from "./components/ProductsTab";
import { i18n } from "../../translate/i18n";
import CategoriesTab from "./components/CategoriesTab";

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  mainPaper: {
    flex: 1,
    padding: 0,
    overflowY: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  tabsHeader: {
    backgroundColor: theme.palette.background.default,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  tabPanel: {
    flex: 1,
    overflowY: 'auto',
    padding: 0,
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`catalog-tabpanel-${index}`}
      aria-labelledby={`catalog-tab-${index}`}
      style={{ height: '100%' }}
      {...other}
    >
      {value === index && (
        <Box height="100%">{children}</Box>
      )}
    </div>
  );
}

const Catalog = () => {
  const classes = useStyles();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <MainContainer className={classes.root}>
      <MainHeader>
        <Title>{i18n.t("catalog.title", "Catálogo")}</Title>
      </MainHeader>
      <Paper className={classes.mainPaper} variant="outlined">
        <div className={classes.tabsHeader}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab label={i18n.t("catalog.tabs.products", "Productos")} />
            <Tab label={i18n.t("catalog.tabs.categories", "Categorías")} />
          </Tabs>
        </div>
        <TabPanel value={tabValue} index={0} className={classes.tabPanel}>
          <ProductsTab />
        </TabPanel>
        <TabPanel value={tabValue} index={1} className={classes.tabPanel}>
          <CategoriesTab />
        </TabPanel>
      </Paper>
    </MainContainer>
  );
};

export default Catalog;